function guidedJourneyKey(clientId: string): string {
  return `consumer-guided-journey:${clientId}`;
}

/**
 * A consumer handed over from guided planning's coverage projection keeps guided planning's header and
 * Back / Next buttons for the rest of the flow. Remembered for the browser session, so a reload keeps
 * the look; entering the flow any other way forgets it.
 */
export function startGuidedJourney(clientId: string) {
  try {
    sessionStorage.setItem(guidedJourneyKey(clientId), 'true');
  } catch {
    // Storage can be unavailable (private browsing); the flow then keeps its own look.
  }
}

export function endGuidedJourney(clientId: string) {
  try {
    sessionStorage.removeItem(guidedJourneyKey(clientId));
  } catch {
    // Without storage nothing was remembered.
  }
}

export function isGuidedJourney(clientId: string): boolean {
  try {
    return sessionStorage.getItem(guidedJourneyKey(clientId)) === 'true';
  } catch {
    return false;
  }
}
